export var loginState = false;
export const KEY = "MarkKieru@55";
export const GOOGLE_MAPS_API_KEY = "AIzaSyDlcuzPo-zZuXSsYA75gzGmRGMQWI0xwhg";

//Live API
// SERVER_IP_ADDRESS = 172.105.244.19;
// API_PORT_NUMBER = :8080
// export const ApiDetails = "/api/";

// export const ApiDetails = "https://185.113.249.176:8080/";
// export const ApiDetails = "https://api.pegasus-pms.co.ke/api/"; 

export const ApiDetails = "https://svr.pegasus-pms.co.ke/api/";
// export const ApiDetails = "https://svr.pegasus-pms.co.ke/api/demo";

export const RECAPTCHA = "6Lc_PkMkAAAAAAxgKyNYSKZVkGnwAVupNHfpsIgJ";
export const SITE_KEY = "6LegSqgkAAAAABBZAUqVzsDq-uNvkDsxtbEz-RRF";
export const SECRET_KEY = "6LegSqgkAAAAAD2vO2OR-cKLXl-Gc9j9flZzCvO-";
// export const SKY_AUTH_ApiDetails = "https://api.pegasus-pms.co.ke/sky_api";
export const TOTP_ApiDetails = "https://svr.pegasus-pms.co.ke/totp" ;

//Local API
// export const ApiDetails = "http://127.0.0.1:8080/";
// export const RECAPTCHA = "6Lc_PkMkAAAAAL1GZw V4XJa3cttFXibzuz9Ega9R";
// export const SKY_AUTH_ApiDetails = "//0.0.0.0:8081";

//Callback Endpoint
// export const ApiDetails = "https://172.105.244.19:8080/";

// https://api.pegasus-pms.co.ke/api/pegasus/visionary/payments /


